<template>
  <input
    type="text"
    placeholder="dd/mm/yyyy"
    v-mask="'##/##/####'"
    class="form-control"
    ref="vFecha"
    value="vFecha"
    @input="handleInput"
  />
</template>

<script>
import moment from "moment";
import { mask } from "vue-the-mask";

export default {
  data() {
    return {
      content: this.value,
    };
  },
  props: ["value"],
  directives: { mask },
  methods: {
    handleInput() {
      let fecha = this.$refs.vFecha.value;
      let arrayFecha = fecha.split("/");
      let fechaArreglada =
        arrayFecha[2] + "-" + arrayFecha[1] + "-" + arrayFecha[0];

      if (moment(fechaArreglada).isValid()) {
        // valida fecha en el tiempo
        let fechaInicio = moment("1920-01-01").format("YYYY-MM-DD");
        let fechaFin = moment().format("YYYY-MM-DD");
        let fechaActual = moment(fechaArreglada).format("YYYY-MM-DD");

        if (fechaActual < fechaInicio || fechaActual > fechaFin) {
          //console.log('Fecha incorrecta');
          this.$emit("input", "");
        } else {
          this.$emit("input", fechaArreglada);
          //console.log('Fecha ok');
        }
      } else {
        //console.log('Fecha incorrecta');
        this.$emit("input", "");
      }
    },
  },
};
</script>

<style></style>
